var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoogle = function SvgGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3498 11.1H12.1798V13.83H18.6898C18.3598 17.64 15.1898 19.27 12.1898 19.27C8.35979 19.27 4.99979 16.25 4.99979 12C4.99979 7.9 8.19979 4.73 12.1998 4.73C15.2898 4.73 17.0998 6.7 17.0998 6.7L18.9998 4.72C18.9998 4.72 16.5598 2 12.0998 2C6.41979 2 2.02979 6.8 2.02979 12C2.02979 17.05 6.15979 22 12.2498 22C17.5998 22 21.4998 18.33 21.4998 12.91C21.4998 11.76 21.3498 11.1 21.3498 11.1Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google.2494938d.svg";
export { ForwardRef as ReactComponent };